module.exports = __webpack_public_path__ + "img/farzana-christopher-20.55210cbd.jpg";